import xss from 'xss';

const options = {
    css: false,
    onTag(tag, html, options) {
        if (tag === 'iframe') {
            return html.replace(/javascript:?/, '')
        }
    },
    // 避免把页面样式过滤掉
    onIgnoreTagAttr(tag, name, value, isWhiteAttr) {
        // 过滤掉标签上的事件
        if (/^[^on]/.test(name)) {
            return name + '="' + xss.escapeAttrValue(value) + '"'
        }
    },
}
const xssFilter = new xss.FilterXSS(options)

export default xssFilter